module.exports = __webpack_public_path__ + "static/media/SOS.logo.c30a5fb3.png";